import {
	IPhotoLibrarySection,
	IPhotoLibrarySectionResponseWithCount,
} from "./../../interfaces/photoLibrary.d";
import {
	DefaultVendorPhotoLibrarySectionIdsEnum,
	DefaultVendorPhotoLibrarySectionNamesEnum,
} from "../../constants/enums";

export const transformPhotoLibrarySections = (
	data: IPhotoLibrarySectionResponseWithCount,
): IPhotoLibrarySection[] => {
	const sections = data?.sections ?? [];
	const allPhotosCount = data?.allPhotosCount ?? 0;
	const uncategorizedPhotosCount = data?.uncategorizedPhotosCount ?? 0;
	const vendorProfileImagesCount = data?.vendorProfileImagesCount ?? 0;

	const allPhotosSection: IPhotoLibrarySection = {
		id: DefaultVendorPhotoLibrarySectionIdsEnum.AllPhotos,
		sectionName: DefaultVendorPhotoLibrarySectionNamesEnum.AllPhotos,
		vendorId: "",
		isSystemSection: true,
		photoCount: allPhotosCount,
		createdAt: `${new Date()}`,
		updatedAt: `${new Date()}`,
		iconName: "Grid",
	};

	const uncategorizedSection: IPhotoLibrarySection = {
		id: DefaultVendorPhotoLibrarySectionIdsEnum.Uncategorized,
		sectionName: DefaultVendorPhotoLibrarySectionNamesEnum.Uncategorized,
		vendorId: "",
		isSystemSection: true,
		photoCount: uncategorizedPhotosCount,
		createdAt: `${new Date()}`,
		updatedAt: `${new Date()}`,
		iconName: "FileQuestion",
	};

	const vendorProfileSection: IPhotoLibrarySection = {
		id: DefaultVendorPhotoLibrarySectionIdsEnum.VendorProfileImages,
		sectionName: DefaultVendorPhotoLibrarySectionNamesEnum.VendorProfileImages,
		vendorId: "",
		isSystemSection: true,
		photoCount: vendorProfileImagesCount,
		createdAt: `${new Date()}`,
		updatedAt: `${new Date()}`,
		iconName: "Image",
	};

	if (!sections || !sections?.length) {
		return [allPhotosSection, uncategorizedSection, vendorProfileSection];
	}

	//cort sections based on created at, if created at is same, then sort by section name
	const sortedSections = [...sections].sort((a, b) => {
		const dateA = new Date(a.createdAt).getTime();
		const dateB = new Date(b.createdAt).getTime();

		if (dateA === dateB) {
			return a.sectionName.localeCompare(b.sectionName);
		}

		return dateA - dateB;
	});

	return [allPhotosSection, ...sortedSections, uncategorizedSection, vendorProfileSection];
};
